import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Amplify } from 'aws-amplify';
import { environment } from 'environments/environment';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.clientId,
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          providers: ['Google', 'Amazon'],
          redirectSignIn: ['https://' + window.location.host],
          redirectSignOut: ['https://' + window.location.host],
          responseType: 'code',
          scopes: ['email', 'openid', 'profile'],
          domain: environment.cognito.oauthDomain,
        },
        email: true,
      },
    },
  },
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
